import { createContext, useContext } from 'react';

/** The mounted dashboard supplies its selected site; tenant scope never implies a factory. */
export const SafetyBoardSiteContext = createContext<string | null>(null);
export const useSafetyBoardSite = () => useContext(SafetyBoardSiteContext);
